import { Unionize } from "./generic";
import { BBox } from "./geometry";

export type ViewCamera = {
  center: [number, number];
  zoom: number;
};

export type ViewLocation = {
  camera: ViewCamera;
  bbox?: BBox;
};

export const MapStyle = ["map", "satellite", "hybrid", "monochrome"] as const;
export type MapStyle = Unionize<typeof MapStyle>;

export type View = {
  layers: {
    [key: string]: boolean;
  };
  location: ViewLocation;
  loading: boolean;
};
